import { Circle } from "@ecco/ui/circle";
import { Flex } from "@ecco/ui/flex";
import { Text } from "@ecco/ui/text";
import { useMicrocopy } from "@lib/contentful/microcopy/MicrocopyContext";
import { CommonCMS, ClickAndCollect } from "@lib/constants/contentful";

interface CheckoutAvailabilityIndicatorProps {
    isAvailableNow: boolean;
}

export const CheckoutAvailabilityIndicator = ({
    isAvailableNow,
}: CheckoutAvailabilityIndicatorProps) => {
    const { getMultiple } = useMicrocopy();

    const microcopies = (() => {
        return getMultiple(CommonCMS.page, [
            ClickAndCollect.available,
            ClickAndCollect.availableSoon,
        ]);
    })();

    return (
        <Flex mt={2} gap={1} alignItems={"center"}>
            <Circle size={"7px"} bg={isAvailableNow ? "green.200" : "yellow.200"} />
            <Text fontSize={"desktopBodyTextTiny"}>
                {isAvailableNow
                    ? microcopies[ClickAndCollect.available]
                    : microcopies[ClickAndCollect.availableSoon]}
            </Text>
        </Flex>
    );
};
